"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const SessionContext_1 = require("./context/SessionContext");
const SelectionContext_1 = require("./context/SelectionContext");
const SessionBuilderContext_1 = require("./context/SessionBuilderContext");
const LayoutSelector_1 = require("./LayoutSelector");
;
const SessionLayout = ({ children }) => {
    console.log("SessionLayout Is running");
    const { builderId, docType } = (0, react_router_dom_1.useParams)();
    // If docType is present, we're in the /new/:docType route
    const isNewSession = !!docType;
    const sessionIdOrNew = isNewSession ? "new" : (builderId || "0");
    const sessionDocType = docType;
    return ((0, jsx_runtime_1.jsx)(SessionContext_1.SessionProvider, { builderId: sessionIdOrNew, docType: sessionDocType, children: (0, jsx_runtime_1.jsx)(SelectionContext_1.SelectionProvider, { children: (0, jsx_runtime_1.jsx)(SessionBuilderContext_1.SessionBuilderProvider, { sessionId: sessionIdOrNew, docType: sessionDocType, children: (0, jsx_runtime_1.jsx)(LayoutSelector_1.LayoutSelector, {}) }) }) }));
};
exports.SessionLayout = SessionLayout;
